import * as Yup from 'yup';

import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';
import {
  DATE_MATCH_REGEXP,
  TESTING_SSN_MATCH_REGEX,
  PRODUCTION_SSN_MATCH_REGEX,
} from 'utils/curo-helpers/validation';

import { ApplyFormFields, IApplyFormValues, availableStates } from './constants';

export const applyFormValidationSchema = Yup.object<Yup.ObjectSchema<IApplyFormValues>>().shape({
  [ApplyFormFields.BorrowerFirstName]: Yup.string().required('First name is required'),
  [ApplyFormFields.BorrowerLastName]: Yup.string().required('Last name is required'),
  [ApplyFormFields.BorrowerSSN]: Yup.string()
    .required('SSN is required')
    .length(9, 'Invalid SSN')
    .matches(
      envs[EnvironmentVariable.Environment] === 'prod'
        ? PRODUCTION_SSN_MATCH_REGEX
        : TESTING_SSN_MATCH_REGEX,
      'Invalid SSN',
    ),
  [ApplyFormFields.BorrowerDateOfBirth]: Yup.string()
    .required('Date of birth is required')
    .matches(DATE_MATCH_REGEXP, 'Invalid date'),
  [ApplyFormFields.BorrowerStreetAddress]: Yup.string().required('Street address is required'),
  [ApplyFormFields.BorrowerCity]: Yup.string().required('City is required'),
  [ApplyFormFields.BorrowerZipOrPostalCode]: Yup.string()
    .required('Zip code is required')
    .length(5, 'Invalid zip code length'),
  [ApplyFormFields.BorrowerState]: Yup.string()
    .required('State is required')
    .oneOf(availableStates, 'Invalid state'),
});
